module.exports = __webpack_public_path__ + "media/images/meta/fb_image-default-d65950c71afc0fbebf98bfc02d4df87c.png";